__turbopack_context__.v({
  "btn": "ScholarshipJourney-module-scss-module__5ceORW__btn",
  "inner": "ScholarshipJourney-module-scss-module__5ceORW__inner",
  "mobileImg": "ScholarshipJourney-module-scss-module__5ceORW__mobileImg",
  "section": "ScholarshipJourney-module-scss-module__5ceORW__section",
  "subtitle": "ScholarshipJourney-module-scss-module__5ceORW__subtitle",
  "textGroup": "ScholarshipJourney-module-scss-module__5ceORW__textGroup",
  "title": "ScholarshipJourney-module-scss-module__5ceORW__title",
  "titleHighlight": "ScholarshipJourney-module-scss-module__5ceORW__titleHighlight",
});
